import { PropType } from "vue"

// General types
export const PROP_TYPE_ANY = undefined as any;
export const PROP_TYPE_NULL = null;
export const PROP_TYPE_ARRAY = Array as PropType<any[]>
export const PROP_TYPE_BOOLEAN = Boolean as PropType<boolean>
export const PROP_TYPE_DATE = Date as PropType<Date>
export const PROP_TYPE_FUNCTION = Function as PropType<(value: any) => void>
export const PROP_TYPE_NUMBER = Number as PropType<number>
export const PROP_TYPE_OBJECT = Object as PropType<object>
export const PROP_TYPE_REG_EXP = RegExp as PropType<RegExp>
export const PROP_TYPE_STRING = String as PropType<string>

// Multiple types
export const PROP_TYPE_ARRAY_FUNCTION = [PROP_TYPE_ARRAY, PROP_TYPE_FUNCTION] as PropType<any[] | FunctionConstructor>
export const PROP_TYPE_ARRAY_OBJECT = [PROP_TYPE_ARRAY, PROP_TYPE_OBJECT] as PropType<any[] | object>
export const PROP_TYPE_ARRAY_OBJECT_STRING = [PROP_TYPE_ARRAY, PROP_TYPE_OBJECT, PROP_TYPE_STRING] as PropType<any[] | object | string>
export const PROP_TYPE_ARRAY_STRING = [PROP_TYPE_ARRAY, PROP_TYPE_STRING] as PropType< | string>
export const PROP_TYPE_BOOLEAN_NUMBER = [PROP_TYPE_BOOLEAN, PROP_TYPE_NUMBER] as PropType<boolean | number>
export const PROP_TYPE_BOOLEAN_NUMBER_STRING = [PROP_TYPE_BOOLEAN, PROP_TYPE_NUMBER, PROP_TYPE_STRING] as PropType<boolean | number | string>
export const PROP_TYPE_BOOLEAN_STRING = [PROP_TYPE_BOOLEAN, PROP_TYPE_STRING] as PropType<boolean | string>
export const PROP_TYPE_DATE_STRING = [PROP_TYPE_DATE, PROP_TYPE_STRING] as PropType<Date | string>
export const PROP_TYPE_FUNCTION_STRING = [PROP_TYPE_FUNCTION, PROP_TYPE_STRING] as PropType<FunctionConstructor | string>
export const PROP_TYPE_NUMBER_STRING = [PROP_TYPE_NUMBER, PROP_TYPE_STRING] as PropType<number | string>
export const PROP_TYPE_NUMBER_OBJECT_STRING = [PROP_TYPE_NUMBER, PROP_TYPE_OBJECT, PROP_TYPE_STRING] as PropType<number | object | string>
export const PROP_TYPE_OBJECT_FUNCTION = [PROP_TYPE_OBJECT, PROP_TYPE_FUNCTION] as PropType<object | FunctionConstructor>
export const PROP_TYPE_OBJECT_STRING = [PROP_TYPE_OBJECT, PROP_TYPE_STRING] as PropType<object | string>

export type MaybeProp<T> = PropType<T | null>;

export const Props = {
	Any: PROP_TYPE_ANY,
	Null: PROP_TYPE_NULL,
	Array: PROP_TYPE_ARRAY,
	Boolean: PROP_TYPE_BOOLEAN,
	Date: PROP_TYPE_DATE,
	Function: PROP_TYPE_FUNCTION,
	Number: PROP_TYPE_NUMBER,
	Object: PROP_TYPE_OBJECT,
	RegExp: PROP_TYPE_REG_EXP,
	String: PROP_TYPE_STRING,
	ArrayFunction: PROP_TYPE_ARRAY_FUNCTION,
	ArrayObject: PROP_TYPE_ARRAY_OBJECT,
	ArrayObjectString: PROP_TYPE_ARRAY_OBJECT_STRING,
	ArrayString: PROP_TYPE_ARRAY_STRING,
	BooleanNumber: PROP_TYPE_BOOLEAN_NUMBER,
	BooleanNumberString: PROP_TYPE_BOOLEAN_NUMBER_STRING,
	BooleanString: PROP_TYPE_BOOLEAN_STRING,
	DateString: PROP_TYPE_DATE_STRING,
	FunctionString: PROP_TYPE_FUNCTION_STRING,
	NumberString: PROP_TYPE_NUMBER_STRING,
	NumberObjectString: PROP_TYPE_NUMBER_OBJECT_STRING,
	ObjectFunction: PROP_TYPE_OBJECT_FUNCTION,
	ObjectString: PROP_TYPE_OBJECT_STRING
}

export default Props;
